module.exports = __webpack_public_path__ + "img/invoice.93b2475d.svg";